import { IGlobalState } from "../../state-management/slices/global/global.slice";
import { ILookupsState } from "../../state-management/slices/lookups/lookups.slice";
import { IOutagesState } from "../../state-management/slices/outages/outages.slice";
import store from "../../state-management/store";

export const getGlobalState = (): IGlobalState => {
  const state = store.getState();
  return state.globalState;
};

export const getOutagesState = (): IOutagesState => {
  const state = store.getState();
  return state.outages;
};

export const getLookupsState = (): ILookupsState => {
  const state = store.getState();
  return state.lookups;
};

export class TestWorker {
  url: string;
  onmessage: (msg?: string) => void;

  constructor(stringUrl: string) {
    this.url = stringUrl;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.onmessage = () => {};
  }

  postMessage(msg: string): void {
    this.onmessage(msg);
  }
}
